import { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { cartsChanged } from "../../../../store/action/cart";
import { setUser } from "../../../../store/action/auth";
import CartService from "../../../../services/cart/Cart";
import HttpService from "../../../../services/http_service/HttpService";
import Http from "../../../../services/http/Http";
import Card from "../../../../components/card";
import RadioGroup from "../../../../components/radio/RadioGroup";
import { Div, AddressContainer } from "./style";
import Spinner from "../../../../components/spinner/Spinner";

const Addresses = (props) => {
  const { user, carts, cartsChanged } = props;

  const [isLoadingGetData, setIsLoadingGetData] = useState(false);
  const [addresses, setAddresses] = useState([]);

  const getAddress = useCallback(() => {
    setIsLoadingGetData(true);

    HttpService(user?.token)
      .get("user/addresses")
      .then((response) => {
        setAddresses(response?.data?.entity?.addresses);
      })
      .catch((error) => {
        Http(error?.response?.status, error?.response?.data?.message, props);
      })
      .finally(() => {
        setIsLoadingGetData(false);
      });
  }, [user]);

  useEffect(() => {
    window.scrollTo(0, 0);

    getAddress();
  }, [getAddress]);

  const handleChange = (stateName, value) => {
    setIsLoadingGetData(true);

    HttpService(user?.token)
      .patch("carts", {
        ...carts,
        [stateName]: value,
        validate_address_service: true,
      })
      .then((response) => {
        CartService.setCart(response.data?.entity, cartsChanged);
      })
      .catch((error) => {
        Http(error?.response?.status, error?.response?.data?.message, props);
      })
      .finally(() => {
        setIsLoadingGetData(false);
      });
  };

  console.log(carts?.address_id);

  return (
    <>
      <AddressContainer>
        <Card className="text-right">
          <Div>
            {isLoadingGetData ? (
              <Div className="d-flex justify-content-center py-3">
                <Spinner size={18} color="primary" />
              </Div>
            ) : (
              <RadioGroup
                itemClassName="mr-0 ml-1"
                name="address_id"
                value={carts?.address_id}
                items={addresses}
                itemValue="id"
                itemLabel="address"
                onChange={(stateName, val) =>
                  handleChange(stateName, val?.value)
                }
              />
            )}
          </Div>
        </Card>
      </AddressContainer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    carts: state.carts?.carts,
  };
};

export default connect(mapStateToProps, { setUser, cartsChanged })(Addresses);
